interface CheckBoxProps {
  checked: boolean;
  onChange: () => void;
  className?: string;
}

const CheckBoxIcon = ({ checked }: { checked: boolean }) => {
  if (checked) {
    return (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.25 10C0.25 4.615 4.615 0.25 10 0.25C15.385 0.25 19.75 4.615 19.75 10C19.75 15.385 15.385 19.75 10 19.75C4.615 19.75 0.25 15.385 0.25 10ZM13.61 8.186C13.67 8.10605 13.7134 8.01492 13.7377 7.91795C13.762 7.82098 13.7666 7.72014 13.7514 7.62135C13.7361 7.52257 13.7012 7.42782 13.6489 7.3427C13.5965 7.25757 13.5276 7.18378 13.4463 7.12565C13.3649 7.06753 13.2728 7.02624 13.1753 7.00423C13.0778 6.98221 12.9769 6.97991 12.8785 6.99746C12.7801 7.01501 12.6862 7.05205 12.6023 7.10641C12.5184 7.16077 12.4462 7.23135 12.39 7.314L9.154 11.844L7.53 10.22C7.38783 10.0875 7.19978 10.0154 7.00548 10.0188C6.81118 10.0223 6.62579 10.101 6.48838 10.2384C6.35097 10.3758 6.27225 10.5612 6.26882 10.7555C6.2654 10.9498 6.33752 11.1378 6.47 11.28L8.72 13.53C8.79699 13.6069 8.8898 13.6662 8.99199 13.7036C9.09418 13.7411 9.20329 13.7559 9.31176 13.7469C9.42023 13.738 9.52546 13.7055 9.62013 13.6519C9.7148 13.5982 9.79665 13.5245 9.86 13.436L13.61 8.186Z"
          fill="#111827"
        />
      </svg>
    );
  } else {
    return (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.25 9.6875L8.3125 11.75L11.75 6.9375M17.25 9C17.25 10.0834 17.0366 11.1562 16.622 12.1571C16.2074 13.1581 15.5997 14.0675 14.8336 14.8336C14.0675 15.5997 13.1581 16.2074 12.1571 16.622C11.1562 17.0366 10.0834 17.25 9 17.25C7.91659 17.25 6.8438 17.0366 5.84286 16.622C4.84193 16.2074 3.93245 15.5997 3.16637 14.8336C2.40029 14.0675 1.7926 13.1581 1.37799 12.1571C0.963392 11.1562 0.75 10.0834 0.75 9C0.75 6.81196 1.61919 4.71354 3.16637 3.16637C4.71354 1.61919 6.81196 0.75 9 0.75C11.188 0.75 13.2865 1.61919 14.8336 3.16637C16.3808 4.71354 17.25 6.81196 17.25 9Z"
          stroke="#C4C6CA"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
};

export const CheckBox = ({ checked, onChange, className }: CheckBoxProps) => {
  return (
    <div
      className={`flex h-5 w-5 items-center justify-center rounded-full transition-colors duration-300 ${className}`}
      onClick={(e) => {
        e.stopPropagation();
        onChange();
      }}
    >
      <CheckBoxIcon checked={checked} />
    </div>
  );
};
